import { render, staticRenderFns } from "./Categories.vue?vue&type=template&id=3adc5291&scoped=true"
import script from "@/views/Settings/Categories/Categories.ts?vue&type=script&lang=ts&external"
export * from "@/views/Settings/Categories/Categories.ts?vue&type=script&lang=ts&external"
import style0 from "@/views/Settings/Categories/categories.scss?vue&type=style&index=0&id=3adc5291&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3adc5291",
  null
  
)

export default component.exports